module.exports = __webpack_public_path__ + "img/service@2x.92a921e7.png";